import type { ReactNode } from 'react';

export const symbol_contact_mail: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M592-524h208q12.75 0 21.38-8.63Q830-541.25 830-554v-126q0-12.75-8.62-21.38Q812.75-710 800-710H592q-12.75 0-21.37 8.62Q562-692.75 562-680v126q0 12.75 8.63 21.37Q579.25-524 592-524Zm104-77 79-60q7.69-6 16.35-1.5Q800-658 800-648q0 1-6 13l-79 60q-8 6-18 6t-18-6l-81-60q-2-2-6-13 0-10 9-14.5t17 1.5l78 60ZM60-120q-24 0-42-18T0-180v-600q0-24 18-42t42-18h840q24 0 42 18t18 42v600q0 24-18 42t-42 18H60Zm531-60h309v-600H60v600h7q44-69 112.5-109T329-329q81 0 149.5 40T591-180ZM414-435q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35ZM143-180h372q-35.61-42.27-84.3-65.64Q382-269 329-269t-101.5 23.5Q179-222 143-180Zm143-297q-17-17-17-43t17-43q17-17 43-17t43 17q17 17 17 43t-17 43q-17 17-43 17t-43-17Zm194-3Z"
		/>
	</svg>
);
